import React from 'react'

function Lock() {
  return (
    <div className="card-body">
      <div className="text-center mb-3">
        <a href="#/"><img className="logo-auth" src="/assets/logo.png" alt="" /></a>
      </div>
      <h4 className="text-center mb-4">Account Locked</h4>
      <form action="index.php">
        <div className="form-group mb-3">
          <label className="form-label">Password</label>
          <div className="position-relative">
            <input type="password" id="dz-password" className="form-control" />
            <span className="show-pass eye">
              <i className="fa fa-eye-slash"></i>
              <i className="fa fa-eye"></i>
            </span>
          </div>
        </div>
        <div className="text-center">
          <button type="submit" className="btn btn-primary btn-block">Unlock</button>
        </div>
      </form>
    </div>
  )
}

export default Lock
